var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPriceHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "#364863"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.85547V8.76007L10.239 10.0394L11.011 8.81449L9.49999 7.95093V5.85549L8 5.85547Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74999 3C6.1104 3 3.9258 4.867 3.55992 7.28573H2L4.25001 9.42861L6.50001 7.28573H5.07581C5.4243 5.65765 6.93918 4.42857 8.74999 4.42857C10.8176 4.42857 12.5 6.03084 12.5 8.00001C12.5 9.96918 10.8176 11.5715 8.74999 11.5715C7.54701 11.5715 6.40844 11.0155 5.70458 10.085L4.4873 10.9193C5.47241 12.2223 7.0658 13.0001 8.74999 13.0001C11.6449 13.0001 14 10.7568 14 8.00004C14 5.24332 11.6449 3 8.74999 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriceHistory);
export default __webpack_public_path__ + "static/media/icon-price-history.72740278341363dd85e0d7e5e64b3e65.svg";
export { ForwardRef as ReactComponent };